import { determineTextClass } from "./determineTextClass"
import { StatusVariant } from "./StatusVariant"
import { statusVariantTokens } from "./statusVariantTokens"

/**
 * Determine the text color class for a status variant.
 * Returns the standard status text color (e.g., blue for info, green for success).
 */
export function determineStatusTextClass(variant: StatusVariant): string {
  return determineTextClass(statusVariantTokens[variant].text)
}
